// Policy is its own frontend domain — kept out of authService.js
// deliberately, even though apiGetPolicies used to live there just because
// it happened to be adjacent to auth-flow code. Nothing here needs an
// authenticated session; both calls are public reads.

// Safe policy metadata (version/title/path/lastUpdated per document type),
// so the frontend never owns its own authoritative copy of a policy
// version.
export async function apiGetPolicies() {
  const res = await fetch("/api/policies");
  const data = await res.json();
  if (!res.ok) throw new Error(data.error ?? "Could not load policy information.");
  return data.policies; // { rules: { documentType, version, title, path, acceptanceMode, lastUpdated }, ... }
}

// The actual versioned Markdown content for one document/version — never
// guessed or cached client-side beyond the browser's own HTTP cache; the
// backend marks it immutable-cacheable since a given version's content
// never changes once published.
export async function apiGetPolicyDocument(documentType, version) {
  const res = await fetch(`/api/policies/${encodeURIComponent(documentType)}/${encodeURIComponent(version)}`);
  const data = await res.json();
  if (!res.ok) throw new Error(data.error ?? "Could not load policy document.");
  return data; // { documentType, version, title, lastUpdated, contentMarkdown }
}
